var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookshelf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bookshelf",
    clipPath: "url(#clip0_10719_216)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.0353 15.5294H2.96468C1.71716 15.5294 0.705853 15.6084 0.705853 15.7059V16.0588C0.705853 16.1563 1.71716 16.2353 2.96468 16.2353H21.0353C22.2828 16.2353 23.2941 16.1563 23.2941 16.0588V15.7059C23.2941 15.6084 22.2828 15.5294 21.0353 15.5294Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 882"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.41174 4.65878L1.41174 13.6941C1.41174 14.3178 2.0438 14.8235 2.8235 14.8235H5.64703C6.42673 14.8235 7.05879 14.3178 7.05879 13.6941L7.05879 4.65878C7.05879 4.03502 6.42673 3.52937 5.64703 3.52937H2.8235C2.0438 3.52937 1.41174 4.03502 1.41174 4.65878Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 39",
    d: "M2.8235 6.35291H5.64703",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 40",
    d: "M2.8235 11.2941H5.64703",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 41",
    d: "M2.8235 12.7059H5.64703",
    stroke: "black",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 883"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.47056 2.11772V13.4118C8.47056 14.1915 9.10263 14.8236 9.88232 14.8236H12.7059C13.4855 14.8236 14.1176 14.1915 14.1176 13.4118V2.11772C14.1176 1.33803 13.4855 0.705959 12.7059 0.705959H9.88232C9.10263 0.705959 8.47056 1.33803 8.47056 2.11772Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 36",
    d: "M9.88232 4.23535H12.7059",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 37",
    d: "M9.88232 11.2942H12.7059",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 38",
    d: "M9.88232 12.7059H12.7059",
    stroke: "black",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 884"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.9706 12.8745L20.5767 3.94027C20.4114 3.32349 19.6669 2.98708 18.9138 3.18888L16.1865 3.91966C15.4333 4.12146 14.9568 4.78505 15.1221 5.40184L17.516 14.3361C17.6812 14.9529 18.4258 15.2893 19.1789 15.0875L21.9062 14.3567C22.6593 14.1549 23.1359 13.4913 22.9706 12.8745Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 42",
    d: "M16.8969 6.41357L19.6111 5.6353",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 43",
    d: "M18.1874 11.1838L20.9015 10.4056",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 44",
    d: "M18.5569 12.5472L21.271 11.769",
    stroke: "black",
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10719_216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16.9412,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookshelf);
export default __webpack_public_path__ + "static/media/bookshelf.5b5047e35523edb0aae66cc2ce411257.svg";
export { ForwardRef as ReactComponent };